/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_No_Plan_BodyInputs */

const en_us2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer a few questions and the app builds a plan for you to review before it counts.`)
};

const pt_br2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda algumas perguntas e o app monta um plano para você revisar antes de valer.`)
};

const es_419_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde unas preguntas y la app arma un plan para que lo revises antes de que cuente.`)
};

const pt_pt2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde a algumas perguntas e a app monta um plano para reveres antes de contar.`)
};

const fr_fr2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponds à quelques questions et l'appli crée un programme que tu valides avant qu'il compte.`)
};

const de_de2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte ein paar Fragen, und die App erstellt einen Plan, den du prüfst, bevor er gilt.`)
};

const it_it2_today_no_plan_body = /** @type {(inputs: Today_No_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi a qualche domanda e l'app crea una scheda da rivedere prima che diventi effettiva.`)
};

/**
* | output |
* | --- |
* | "Answer a few questions and the app builds a plan for you to review before it counts." |
*
* @param {Today_No_Plan_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_no_plan_body = /** @type {((inputs?: Today_No_Plan_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_No_Plan_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_no_plan_body(inputs)
	if (locale === "es-419") return es_419_today_no_plan_body(inputs)
	if (locale === "pt-PT") return pt_pt2_today_no_plan_body(inputs)
	if (locale === "fr-FR") return fr_fr2_today_no_plan_body(inputs)
	if (locale === "de-DE") return de_de2_today_no_plan_body(inputs)
	if (locale === "it-IT") return it_it2_today_no_plan_body(inputs)
	return en_us2_today_no_plan_body(inputs)
});
export { today_no_plan_body as "today.no_plan_body" }